/**
 * Estilo compartilhado para botões de ponto no RC3 (missão / entrega PUDU).
 * Mantém texto longo dentro do botão (quebra de linha).
 */
export const containedMissionPointButtonSx = {
    textTransform: 'uppercase',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    lineHeight: 1.35,
    padding: '14px 18px',
    minHeight: 52,
};

export const outlinedMissionPointButtonSx = {
    ...containedMissionPointButtonSx,
    borderWidth: 2,
    color: '#90caf9',
    borderColor: 'rgba(144, 202, 249, 0.55)',
};
